import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationClassEnum } from '../../models/notification-class.enum';

@Injectable({
  providedIn: 'root'
})
export class CVANotificationService {

  constructor(
    private readonly _snackBar: MatSnackBar
  ) { }

  showNotification(message: string, notificationType: NotificationClassEnum = NotificationClassEnum.INFO, duration: number = 5000) {
    if (!message?.trim().length) return;
    this._snackBar.open(message, undefined, {
      panelClass: [notificationType],
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      politeness: 'polite',
    });
  }
}
